import pyFormCheckbox from 'pylon-vue/src/components/form-checkbox/form-checkbox-group';

const sFormCheckbox = {
    name: 'sFormCheckboxGroup',
    extends: pyFormCheckbox,
    props: {
        autocomplete: {
            default: "off"
        }
    }
}

export default sFormCheckbox


let x =
    {
        "action": "createOnly",
        "lookupField": "email",
        "input": [
            {
                "email": "kjashaedd-1@klooblept.com",
                "firstName": "Kataldar-1",
                "postalCode": "04828"
            },
            {
                "email": "kjashaedd-2@klooblept.com",
                "firstName": "Kataldar-2",
                "postalCode": "04828"
            },
            {
                "email": "kjashaedd-3@klooblept.com",
                "firstName": "Kataldar-3",
                "postalCode": "04828"
            }
        ]
    }